import {
    defaultInitialState,
    DynamicFilterValues,
} from '../../Filter/filterReducer';

export const convertQueryStringToDynamicFilters = (
    queryString: string,
): DynamicFilterValues => {
    const result: DynamicFilterValues = {};
    if (!queryString) {
        return {};
    }

    queryString.split(',').forEach(filterString => {
        const [filterIndex, filterValue] = filterString.split('=');

        result[parseInt(filterIndex)] = filterValue;
    });

    return result;
};
export const convertDynamicFiltersToQueryString = (
    dynamicFilters: DynamicFilterValues | string = {},
): string => {
    if (typeof dynamicFilters === 'string') {
        return dynamicFilters;
    }
    const result = Object.keys(dynamicFilters).map(filterKey => {
        const filterIndex = parseInt(filterKey);
        const value = dynamicFilters[filterIndex];
        return `${filterIndex}=${value}`;
    });

    return result.join(',');
};

export const convertQueryStringToSelectedValues = (queryString: string) => {
    return queryString.split(',').filter(str => str !== '');
};

export const convertSelectedValuesToQueryString = (
    selectedUuids: string[] = [], // because we're using the comparisonSelectedUuidsSelector in config
) => {
    return selectedUuids.join(',');
};

export const convertSearchValueToQueryString = (searchTerm: string) => {
    if (searchTerm === undefined || searchTerm === 'undefined') {
        return defaultInitialState.searchTerm;
    }
    return searchTerm;
};

export const convertSearchStringToValue = (queryString: string) => {
    if (queryString === 'undefined') {
        return defaultInitialState.searchTerm;
    }
    return queryString;
};

export const convertStartsWithValueToQueryString = (startsWith: string) => {
    if (startsWith === undefined || startsWith === 'undefined') {
        return defaultInitialState.startsWith;
    }
    return startsWith;
};

export const convertStartsWithStringToValue = (queryString: string) => {
    if (queryString === 'undefined') {
        return defaultInitialState.startsWith;
    }
    return queryString;
};
